var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('content-card',{attrs:{"title":"Ferienübersicht Alle","cardIcon":"fas fa-list"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('vacation-table',{attrs:{"pageSection":"VacationOverviewAll"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }